/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'RideRecord',dictionary:{"de":{"references":{"projectTimeReport":"Baustellenbericht","worker":"Mitarbeiter"},"distanceKm":"Distanz [km]","isPrivateRide":"Private Fahrt","remark":"Anmerkung"},"en":{"references":{"projectTimeReport":"Construction Report","worker":"Worker"},"distanceKm":"Distance [km]","isPrivateRide":"Private Ride","remark":"Remark"}}})
import { Login } from './Login';
import { Worker } from './Worker';
import { Project } from './Project';
import { ProjectTimeReport } from './ProjectTimeReport';

export class RideRecord extends _BaseModel {
	
	static toString() {
		return 'RideRecord'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.RideRecord.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'RideRecord', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.RideRecord.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'RideRecord', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.RideRecord.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'RideRecord', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'RideRecord', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'RideRecord', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.RideRecord.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'RideRecord', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.RideRecord'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof RideRecord) || _BaseModel.t('rules.reference', {modelName:'RideRecord', path:'meta.currentDocument'}) ],
				model: RideRecord,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'RideRecord', path:'meta.revisions'}) ],
				model: RideRecord,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	workers:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'RideRecord', path:'references.workers'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	project:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Project'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'RideRecord', path:'references.project'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Project) || _BaseModel.t('rules.reference', {modelName:'RideRecord', path:'references.project'}) ],
				model: Project,
				returnObject: true,
},
    
	},
	
					
	projectTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectTimeReport) || _BaseModel.t('rules.reference', {modelName:'RideRecord', path:'references.projectTimeReport'}) ],
				model: ProjectTimeReport,
				returnObject: true,
},
    
	},
	
},
				
	distanceKm:{
		type: 'number',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.RideRecord.distanceKm'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'RideRecord', path:'distanceKm'}),(value)=> (value === undefined || value === null || typeof +value === 'number') || _BaseModel.t('rules.type.number', {modelName:'RideRecord', path:'distanceKm'}) ],
},
    
	},
	
				
	isPrivateRide:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.RideRecord.isPrivateRide'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'RideRecord', path:'isPrivateRide'}) ],
},
    
	},
	
				
	remark:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.RideRecord.remark'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'RideRecord', path:'remark'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.RideRecord._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, distanceKm='', isPrivateRide=false, remark='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.distanceKm=distanceKm;
		this.isPrivateRide=isPrivateRide;
		this.remark=remark;
		this._id=_id;
	}

	static create(data) {
		return new RideRecord(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof RideRecord || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : RideRecord.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof RideRecord ? item : RideRecord.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({workers=[], project=undefined, projectTimeReport=undefined, }={}){
		if(Array.isArray(workers)){
			this.workers=[];
			for(const item of workers){
				if(typeof item === 'string') this.workers.push(item)
				else if(typeof item === 'object')
					this.workers.push(item instanceof Worker ? item : Worker.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.workers=workers;
		}
		this.project= (project instanceof Project || typeof project === 'string' || !project) ? project : Project.create(project);
		this.projectTimeReport= (projectTimeReport instanceof ProjectTimeReport || typeof projectTimeReport === 'string' || !projectTimeReport) ? projectTimeReport : ProjectTimeReport.create(projectTimeReport);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}
